﻿import { useCallback, useEffect, useState } from "react";
import Pageheader from "../common/Pageheader";
import { FETCH_EXPENSES } from "../../constant/Apipath";
import {
  Button,
  Stack,
  Box,
  Typography,
  Checkbox,
  Card,
  List,
  ListItem,
  ListItemIcon,
  ListItemButton,
  ListItemText,
  useMediaQuery
} from "@mui/material";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import Addexpenses from "./Addexpenses";
import Emptydata from "../common/Emptydata";
import Loader from "../../common/Loader";
import moment from "moment";
import Sendexpenses from "./Sendexpenses";
import { RequestQuote } from "@mui/icons-material";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTheme } from "@emotion/react";
import { English } from "../../constant/EnglishFallback";
import ViewExpenses from "./ViewExpenses";
import AdContainer from "../common/AdContainer";
import GoogleAd from "../common/GoogleAd";

export default function Expenses() {
  // 1.Declaration of hooks
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // 2.Get the data from redux
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);

  // 3.Declaration of states
  const [expenseList, setExpenselist] = useState([]);
  const [activeTab, setActiveTab] = useState("UNSENT");
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [showAddExpensesModal, setShowAddExpensesModal] = useState(false);
  const [showSendModal, setShowSendModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [saveExpensesFlag, setSaveExpensesFlag] = useState(false);
  const [showEditExpensesModal, setShowEditExpensesModal] = useState(false);

  const LanguageData = multiLanguageData?.Expenses || {};
  const {
    TEXT_HEADER = English.Expenses.TEXT_HEADER,
    TEXT_UNSENT = English.Expenses.TEXT_UNSENT,
    TEXT_SENT = English.Expenses.TEXT_SENT,
    BUTTON_ADD_EXPENSE = English.Expenses.BUTTON_ADD_EXPENSE,
    BUTTON_SEND = English.Expenses.BUTTON_SEND,
    TEXT_NO_EXPENSES_PLACEHOLDER = English.Expenses.TEXT_NO_EXPENSES_PLACEHOLDER,
    TEXT_NO_SEND_EXPENSES_PLACEHOLDER = English.Expenses.TEXT_NO_SEND_EXPENSES_PLACEHOLDER
  } = LanguageData || {};

  // 5.API calling Function
  const fetchExpenses = useCallback(
    async (pageNumber) => {
      try {
        if (pageNumber === 1) {
          setIsLoader(true);
        }
        setAllDataLoaded(true);
        const obj = {
          PageNr: pageNumber,
          NrOfRecPerPage: 10,
          FullSearch: "",
          UserId: Number(loginData?.userInformation?.UserId),
          IncludeRecordNr: "true",
          TypeOfObjectReturned: "",
          SearchList: [
            {
              UserId: Number(loginData?.userInformation?.UserId),
              isSent: activeTab === "SENT" ? true : false
            }
          ],
          SortList: [
            {
              FieldName: "Id",
              Direction: "DESC"
            }
          ]
        };
        const fetchExpensesRes = await Postrequestcall(FETCH_EXPENSES, obj, loginData?.accessToken);
        const updatedFetchExpensesRes =
          fetchExpensesRes.data?.data?.map((item) => ({
            ...item,
            expand: false,
            checked: false,
            isShowDetail: false
          })) || []; // Ensure it's always an array

        setExpenselist((prevList) => {
          const newList =
            pageNumber === 1 ? updatedFetchExpensesRes : [...prevList, ...updatedFetchExpensesRes];
          return newList;
        });
        setIsLoader(false);
        setAllDataLoaded(false);
      } catch (error) {
        setIsLoader(false);
        setAllDataLoaded(false);
        console.log("fetchExpenses-> Error When Fetching Expenses: ", error);
      }
    },
    [activeTab]
  );

  //4.Declaration of useEffect
  useEffect(() => {
    fetchExpenses(pageNumber);
  }, [fetchExpenses]);

  const onCheckBoxClick = (e, getItem) => {
    e.preventDefault();
    e.stopPropagation();
    let getList = expenseList?.map((item) => {
      if (item?.id === getItem?.id) {
        return {
          ...item,
          checked: getItem?.checked === true ? false : true
        };
      } else {
        return {
          ...item
        };
      }
    });
    setExpenselist(getList);
  };

  const onSendClick = () => {
    setShowSendModal(true);
  };

  const handleViewClick = (item) => {
    setSelectedExpense(item);
    setShowEditExpensesModal(true);
  };

  const handleClearCheck = () => {
    if (activeTab === "UNSENT") {
      let getList = expenseList?.map((item) => {
        return {
          ...item,
          checked: false
        };
      });
      setExpenselist(getList);
    }
  };

  const handleTabChange = (tabname) => {
    setPageNumber(1);
    setActiveTab(tabname);
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const renderExpensesList = (itemList) => {
    return itemList.map((item, index) => (
      <Card key={item.id} className="pagelist-content" sx={{ marginTop: "0px" }}>
        <ListItem sx={{ m: 0, alignItems: "center" }} disablePadding secondaryAction={ <Stack direction={"row"} spacing={1}>
              <Typography variant="h6" sx={{ color: "primary" }}>
                $ {item.totalAmount ? item.totalAmount.toFixed(2) : ""}
              </Typography>
            </Stack>
          }>
          <ListItemButton
            sx={{ p: 0, pl: item.isSent ? 1 : 2 }}
            onClick={() => handleViewClick(item)}>
            <ListItemIcon sx={{ minWidth: "10px" }}>
              {!item.isSent && (
                <Checkbox
                  size="medium"
                  edge="start"
                  checked={item.checked}
                  onClick={(e) => onCheckBoxClick(e, item)}
                />
              )}
            </ListItemIcon>
            <ListItemText
              sx={{ pl: 1 }}
              primary={item.description}
              secondary={moment(item.expenseDate).format("MMMM DD, YYYY")}
            />
          </ListItemButton>
        </ListItem>
      </Card>
    ));
  };

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3 }}>
      <Pageheader headerName={TEXT_HEADER} />
      <Card className="main-content-card">
        <>
          {isLoader ? (
            <Loader />
          ) : (
            <>
              <Stack direction={"row"} sx={{ pb: 1.5,  justifyContent: "space-between" }} >
                <Stack direction={"row"} spacing={1}>
                  <Button
                    className={`active-btn ${activeTab === "UNSENT" ? "active" : ""}`}
                    size="small"
                    onClick={() => handleTabChange("UNSENT")}>
                    {TEXT_UNSENT}
                  </Button>
                  <Button
                    className={`active-btn ${activeTab === "SENT" ? "active" : ""}`}
                    size="small"
                    onClick={() => handleTabChange("SENT")}>
                    {TEXT_SENT}
                  </Button>
                </Stack>
                <Stack direction={"row"} spacing={1}>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => setShowAddExpensesModal(true)}>
                    {BUTTON_ADD_EXPENSE}
                  </Button>

                  <Button
                    size="small"
                    variant="contained"
                    onClick={onSendClick}
                    disabled={expenseList?.filter((item) => item?.checked === true).length === 0}>
                    {BUTTON_SEND}
                  </Button>
                </Stack>
              </Stack>

              <Box className="main-content-card-list" id="scrollablediv_prodcut">
                {expenseList.length !== 0 ? (
                  <InfiniteScroll
                    dataLength={expenseList?.length}
                    next={async () => {
                      increaseOffset((pageNr) => {
                        fetchExpenses(pageNr);
                      });
                    }}
                    hasMore={true}
                    loader={
                      !allDataLoaded ? null : (
                        <h4 style={{ display: "flex", justifyContent: "center" }}>
                          <Loader />
                        </h4>
                      )
                    }
                    scrollableTarget="scrollablediv_prodcut">
                    <List disablePadding>
                      <Stack sx={{ gap: 1 }} >
                        {renderExpensesList(expenseList)}
                      </Stack>
                    </List>
                  </InfiniteScroll>
                ) : (
                  <Box className="empty-data-card">
                    <Emptydata
                      icon={<RequestQuote className="emptydata-icon" />}
                      firstText={
                        activeTab == "UNSENT"
                          ? TEXT_NO_EXPENSES_PLACEHOLDER
                          : TEXT_NO_SEND_EXPENSES_PLACEHOLDER
                      }
                    />
                  </Box>
                )}
              </Box>
            </>
          )}
          {/* Display ad at the bottom of the list */}
          <AdContainer />
        </>
      </Card>
      {showAddExpensesModal && (
        <Addexpenses
          isOpen={showAddExpensesModal}
          fetchExpenses={fetchExpenses}
          editListItemDetails={selectedExpense}
          onClose={() => {
            handleClearCheck();
            setSelectedExpense(null);
            setShowAddExpensesModal(false);
          }}
          setSaveExpensesFlag={setSaveExpensesFlag}
          setShowEditExpensesModal={setShowEditExpensesModal}
        />
      )}
      {showSendModal && (
        <Sendexpenses
          isOpen={showSendModal}
          close={() => {
            handleClearCheck();
            setSelectedExpense(null);
            setShowSendModal(false);
          }}
          fetchExpenses={fetchExpenses}
          sendExpenses={expenseList?.filter((item) => {
            return activeTab === "UNSENT"
              ? !item?.isSent && item?.checked === true
              : item?.isSent && item?.checked === true;
          })}
        />
      )}
      {showEditExpensesModal && (
        <ViewExpenses
          openModal={showEditExpensesModal}
          closeModal={() => {
            setShowEditExpensesModal(false);
            setSaveExpensesFlag(false);
            setSelectedExpense(null);
          }}
          expensesDataId={selectedExpense}
          setShowAddExpensesModal={setShowAddExpensesModal}
          setSelectedExpense={setSelectedExpense}
          saveExpensesFlag={saveExpensesFlag}
          fetchExpensesData={fetchExpenses}
          activeTab={activeTab}
        />
      )}
    </Box>
  );
}

